export const defaultLanguageKey = 'en';

export const languages = ['en', 'es', 'pt'];

export const MappedLanguage = {'Castellano': 'es', 'English': 'en', 'Português': 'pt'};

export const MappedFlags = {'en': 'GB', 'es': 'ES', 'pt': 'PT'};